import checkUserNameLegacy from './check_username_legacy.js';
import checkUserName from './check_username.js';
import checkEmailLegacy from './check_email_legacy.js';
import checkEmail from './check_email.js';
import checkAllFields from './check_all_fields.js';

export default {
    checkUserNameLegacy,
    checkUserName,
    checkEmailLegacy,
    checkEmail,
    checkAllFields,
};
